import {mixpanel} from "../util/mixpanel";
import {getDefaultTemperatureUnits} from "../util/localization";
import {manager} from "../weather/weather_manager";

export function getTempUnits() {
    return localStorage.getItem("temp-units") || getDefaultTemperatureUnits();
}

function saveTempUnits(unit) {
    localStorage.setItem('temp-units', unit);
}

export function celsiusToFahrenheit(t) {
    return Math.round((Number(t) * 9 / 5)) + 32;
}

function fahrenheitToCelsius(t) {
    return Math.round((Number(t) - 32) * 5 / 9);
}


export function switchTempUnits(event) {
    let inactiveUnit = event.target;
    let name = inactiveUnit.getAttribute("name");
    let value = inactiveUnit.getAttribute("data-value");

    mixpanel.track('Settings', {"value": value, "name": name});

    const convertTemperature = (conversionFunc, unit) => {
        let cur_temp_el = document.getElementById("cur_temp");
        cur_temp_el.textContent =`${conversionFunc(cur_temp_el.textContent)}`;
        saveTempUnits(unit);
        manager.cards.forEach(c => {
            c.updateTempText();
            c.updateWindSpeed();
        })
    }

    if (value === "F") {
        // convert to Fahrenheit
        convertTemperature(celsiusToFahrenheit, 'F');
    } else if (value === "C") {
        // convert to Celsius
        convertTemperature(fahrenheitToCelsius, 'C');
    }
}

export function initLocation() {
    let locationInput = document.getElementById("autocompleteInput");
    locationInput.value = document.getElementById("locality_text").textContent;
}